export const TicketState = {
    OPEN: "Open",
    ONHOLD: "On hold",
    CLOSED: "Closed",
    CLOSED_COMPLETED_IN_OFFICE: "Closed - Completed in office",
    CLOSED_INCOMPLETE: "Closed - Unable to complete"
}

export const TicketStateIds = {
    OPEN: 1,
    ONHOLD: 2,
    CLOSED: 3,
    CLOSED_COMPLETED_IN_OFFICE: 4,
    CLOSED_INCOMPLETE: 5
}